import {createMultiPathSVG} from './TEMPLATE'

// phosphor: magnifying-glass-minus
export const MagnifyingGlassX_Stroke2_Corner0_Rounded_Large =
  createMultiPathSVG({
    paths: [
      'M152,112a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h64A8,8,0,0,1,152,112Zm77.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88.11,88.11,0,1,1,11.31-11.31l50.07,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z',
    ],
    viewBox: '21.333 21.333 213.333 213.333',
  })

// phosphor: magnifying-glass-fill (fill weight)
export const MagnifyingGlass_Filled_Stroke2_Corner0_Rounded =
  createMultiPathSVG({
    paths: [
      'M168,112a56,56,0,1,1-56-56A56,56,0,0,1,168,112Zm61.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88,88,0,1,1,11.32-11.31l50.06,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z',
    ],
    viewBox: '0 0 256 256',
  })

// phosphor: magnifying-glass
export const MagnifyingGlass_Stroke2_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z',
  ],
  viewBox: '0 0 256 256',
})
